import {css} from 'lit';

/* eslint-disable prettier/prettier */
export default css`:root {
  /* fonts */
  --font-title: "Noto Sans", sans-serif;
  --font-content: "Noto Sans", sans-serif;
  --font-code: "Noto Sans Mono", monospace;
  /* colors */
  --color-body: #151218;
  --color-body-contrast: #f4f5f8;
  --color-medium: #948f99;
  --color-medium-contrast: #f4f5f8;
  --color-primary: #d3bcfd;
  --color-primary-contrast: #222428;
  --color-secondary: #cdc2db;
  --color-secondary-contrast: #222428;
  --color-info: #a4c9fe;
  --color-info-contrast: #222428;
  --color-success: #bbce8a;
  --color-success-contrast: #222428;
  --color-warning: #fdb883;
  --color-warning-contrast: #222428;
  --color-danger: #ffb4ab;
  --color-danger-contrast: #222428;
  /* gradients */
  --gradient-direction: 90deg;
  /* sizes */
  --size-base: 16px;
  --size-text: 1;
  --size-space: 1;
  --size-radius: .25;
  --size-border: 1px;
  --size-outline: 1px;
  --size-line: 1.5;
  --size-letter: normal;
  /* shadows */
  --shadow-xs: 0 0 0 1px #12111226;
  --shadow-sm: 0 1px 3px 0 #12111233, 0 1px 2px 0 #12111229;
  --shadow-md: 0 4px 6px -1px #12111233, 0 2px 4px -1px #12111229;
  --shadow-lg: 0 20px 25px -5px #12111233, 0 10px 10px -5px #12111224;
  --shadow-xl: 0px 0px 0px 1px #12111233, 0px 5px 10px #1211124d, 0px 15px 40px #12111280;
  --shadow-inset: inset 0 2px 4px 0 #12111226;
}`;
/* eslint-enable prettier/prettier */
